import { render, staticRenderFns } from "./EditAgentBots.vue?vue&type=template&id=1df5f283&"
import script from "./EditAgentBots.vue?vue&type=script&lang=js&"
export * from "./EditAgentBots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports